import { useContext } from "react";
import { RouteComponentProps, __RouterContext } from "react-router";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- load-bearing: a concrete type breaks the build or changes behaviour; revisit during refactor/stack upgrade
export function useRouter<TParams = any>() {
  return useContext(__RouterContext) as RouteComponentProps<TParams>;
}
